import { ArrowRightOutlined } from "@ant-design/icons";

import { percentageChangeRoot } from "./PercentageChange.css";

export type PercentageChangeProps =
    | { fromPercentage: number; toPercentage: number }
    | { noChangePercentage: number }
    | null;
function isNoChangePercentage(
    value: PercentageChangeProps
): value is { noChangePercentage: number } {
    return value !== null && "noChangePercentage" in value;
}

export function PercentageChange({ value }: { value: PercentageChangeProps }) {
    if (value === null) {
        return <span>-</span>;
    }
    if (isNoChangePercentage(value)) {
        return <span>{value.noChangePercentage}%</span>;
    }
    return (
        <div className={percentageChangeRoot}>
            {value.fromPercentage}% <ArrowRightOutlined /> {value.toPercentage}%
        </div>
    );
}
